import { render, staticRenderFns } from "./IconSigning.vue?vue&type=template&id=06b56fec&"
import script from "./IconSigning.vue?vue&type=script&lang=ts&"
export * from "./IconSigning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports